import { Card } from '@/shared/ui/Card'
import { RewardBadge } from '@/shared/ui/RewardBadge'

import { missionShowCardBodyClass, missionShowCardClass } from './showCard'

type MissionRewardCardProps = {
  pointReward?: number | null
  coinReward?: number | null
  walletPoints?: number
  walletCoins?: number
}

export const MissionRewardCard = ({
  pointReward,
  coinReward,
  walletPoints = 0,
  walletCoins = 0
}: MissionRewardCardProps) => {
  const hasReward = (pointReward ?? 0) > 0 || (coinReward ?? 0) > 0
  if (!hasReward) return null

  return (
    <Card
      className={`${missionShowCardClass} border-2 border-green-100 bg-gradient-to-br from-green-50/80 to-white`}
    >
      <Card.Body className={missionShowCardBodyClass}>
        <h2 className="m-0 text-sm font-bold text-gray-900">
          Recompensa recebida
        </h2>

        <RewardBadge.Group>
          {(pointReward ?? 0) > 0 && (
            <RewardBadge type="xp" value={`+${pointReward}`} variant="inline" />
          )}
          {(coinReward ?? 0) > 0 && (
            <RewardBadge
              type="coins"
              value={`+${coinReward}`}
              variant="inline"
            />
          )}
        </RewardBadge.Group>

        <div className="border-t border-green-100 pt-4">
          <span className="text-caps font-bold uppercase tracking-wide text-gray-500">
            Novo saldo
          </span>
          <div className="mt-2 flex flex-wrap gap-3">
            <RewardBadge type="xp" value={walletPoints} variant="inline" />
            <RewardBadge type="coins" value={walletCoins} variant="inline" />
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}
